<template>
	<div class="container">
		<el-form ref="form" label-width="100px" class="modify-form" :model="form" :rules="rules">
			<el-form-item label="现居住地" :error="formError.address">
				<el-input v-model="form.address" placeholder="请输入现居住地名称"></el-input>
			</el-form-item>
			<el-form-item label="邮政编码" :error="formError.post">
				<el-input v-model="form.post" placeholder="请输入邮政编码"></el-input>
			</el-form-item>
			<el-form-item label="手机号码" :error="formError.phone">
				<el-input v-model="form.user_phone" placeholder="请输入手机号码"></el-input>
			</el-form-item>
			<el-form-item label="电子邮箱" :error="formError.email">
				<el-input v-model="form.email" placeholder="请输入电子邮箱"></el-input>
			</el-form-item>
			<div style="text-align:center">
				<el-button type="primary" @click="submit" :loading="loading">保存</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { editContact } from "@/api/user";

export default {
	data() {
		return {
			form: { ...this.$store.state.user } || {},
			rules: {},
			formError: {},
			loading: false
		};
	},
	computed: {
		...mapState({ guoji: "guoji", minzu: "minzu" })
	},
	methods: {
		submit() {
			var _this = this;
			let axiosData = {
				address: this.form.address,
				post: this.form.post,
				phone: this.form.user_phone,
				email: this.form.email
			};

			this.$refs.form.validate(valid => {
				if (valid) {
					this.loading = true;
					editContact(axiosData)
						.then(res => {
							if (res && res.code === 200) {
								this.$message({
									type: "success",
									message: "修改成功",
									duration: 1000,
									onClose() {
										_this.$router.go(-1);
									}
								});
							} else if (res && res.errors) {
								//表单格式错误
								this.formError = this.$transformError(
									res.errors
								);
							} else {
								this.$message.error(res.message);
							}
						})
						.finally(() => {
							this.loading = false;
						});
				}
			});
		}
	}
};
</script>


<style lang="scss" scoped>
.modify-form {
	margin-top: 20px;
}
</style>
